/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ShortcutsContainerShortcutsQueryVariables = {
    after?: string | null | undefined;
    first?: number | null | undefined;
};
export type ShortcutsContainerShortcutsQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"ShortcutsContainer_shortcuts">;
};
export type ShortcutsContainerShortcutsQuery = {
    readonly response: ShortcutsContainerShortcutsQueryResponse;
    readonly variables: ShortcutsContainerShortcutsQueryVariables;
};



/*
query ShortcutsContainerShortcutsQuery(
  $after: String
  $first: Int
) {
  ...ShortcutsContainer_shortcuts
}

fragment ShortcutsContainer_shortcuts on Query {
  shortcuts(first: $first, after: $after) {
    totalCount
    edges {
      node {
        id
        _id
        name
        url
        __typename
      }
      cursor
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShortcutsContainerShortcutsQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ShortcutsContainer_shortcuts"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShortcutsContainerShortcutsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ShortcutConnection",
        "kind": "LinkedField",
        "name": "shortcuts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ShortcutEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Shortcut",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "ShortcutList_shortcuts",
        "kind": "LinkedHandle",
        "name": "shortcuts"
      }
    ]
  },
  "params": {
    "cacheID": "5ab76720ae263f5207b0ee627e8a27fe",
    "id": null,
    "metadata": {},
    "name": "ShortcutsContainerShortcutsQuery",
    "operationKind": "query",
    "text": "query ShortcutsContainerShortcutsQuery(\n  $after: String\n  $first: Int\n) {\n  ...ShortcutsContainer_shortcuts\n}\n\nfragment ShortcutsContainer_shortcuts on Query {\n  shortcuts(first: $first, after: $after) {\n    totalCount\n    edges {\n      node {\n        id\n        _id\n        name\n        url\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      startCursor\n      endCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '41f2cc03d47e18aeef0b8dc906ba798d';
export default node;
